import { FunctionComponent } from 'react';
import { core } from '@tock/coretypes';
import LocationAwareCreditCardForm from 'forms/LocationAwareCreditCardForm';

interface Props {
  buttonText?: string;
  disabled?: boolean;
  onCardCreated?(card: core.PaymentCard): void;
}

const AddCreditCardForm: FunctionComponent<Props> = ({
  buttonText = 'Save this card',
  onCardCreated,
}) => {
  const handleSubmit = async (card: core.PaymentCard) => {
    if (onCardCreated) {
      onCardCreated(card);
    }
  };

  return (
    <LocationAwareCreditCardForm
      title="Add a payment method"
      submitLabel={buttonText}
      onSubmit={handleSubmit}
      requireTurnstile
    />
  );
};

export default AddCreditCardForm;
